export const focusRing = {
  ":focus-visible": {
    outlineColor: (theme: { palette: { primary: { main: any } } }) => theme.palette.primary.main,
    outlineStyle: "solid",
    outlineWidth: "2px",
  },
};

export const focusPagination = {
  "& .MuiIconButton-colorInherit": {
    ":focus-visible": {
      outlineColor: (theme: { palette: { secondary: { main: any } } }) =>
        theme.palette.secondary.main,
      outlineStyle: "solid",
      outlineWidth: "2px",
    },
  },
};

export const focusMenu = {
  "& .MuiTablePagination-menuItem": {
    ":focus-visible": {
      outlineColor: (theme: { palette: { secondary: { main: any } } }) =>
        theme.palette.secondary.main,
      outlineStyle: "solid",
      outlineWidth: "2px",
    },
  },
};

export const focusBorder = {
  ":focus-visible": {
    borderColor: (theme: { palette: { secondary: { light: any } } }) =>
      theme.palette.secondary.light,
    borderStyle: "solid",
    borderWidth: "2px",
  },
};
